import { parseAmountToPence } from '@/helpers/parseAmountToPence'

/**
 * The free checker saves one Gift Aided total. When a claim-year statement
 * exists, that total is the statement plus anything the donor adds. The
 * statement figure is not stored again; it is read from the statement.
 */

/** Extra donations typed under the statement. Blank or zero means none. */
export function additionalGivingPence(input: string): number | null {
  const trimmed = input.trim()
  if (trimmed === '') return 0

  const pounds = Number(trimmed.replace(/[£,\s]/g, ''))
  if (pounds === 0) return 0

  return parseAmountToPence(trimmed)
}

/**
 * Combined Gift Aided total in pence.
 * With no statement, the typed amount is the whole total and must be above zero.
 * With a statement, a blank extra box keeps the statement total.
 * Returns null when the typed amount is not a valid number.
 */
export function combinedGivingPence(
  statementPence: number,
  additionalInput: string
): number | null {
  const additional = additionalGivingPence(additionalInput)
  if (additional === null) return null

  if (statementPence <= 0) {
    return additional > 0 ? additional : null
  }

  return statementPence + additional
}

/** What to show in the extra box when a saved total is opened again. */
export function additionalInputFromSavedTotal(
  totalPence: number,
  statementPence: number
): string {
  if (statementPence <= 0) return (totalPence / 100).toFixed(2)

  const extra = totalPence - statementPence
  if (extra <= 0) return ''

  return (extra / 100).toFixed(2)
}
